<div class="card" style="background-color: transparent!important;">
  <div class="content">
    <h1 class="pb-4r mt-3"><img src="assets/images/youtine-logo-white.svg" class="mx-auto" width="240px"></h1>
    <section data-id="form">
      <h1 class="mb-4 text-white">Passwort vergessen?</h1>
      <p class="mt-3 text-white font-weight-bolder">
        Kein Problem: Gib deine E-Mail Adresse ein und wir schicken dir eine E-Mail zu, mit der du ein neues Passwort setzen kannst.
      </p>
      <form data-id="password-reset-request-form">
        <div class="input-style input-style-always-active no-borders has-icon validate-field mb-5 mt-5">
          <i class="fa fa-envelope"></i>
          <input type="email"
                 name="email"
                 class="form-control"
                 id="input-email"
                 required>
          <label for="input-email" class="color-primary text-uppercase font-700 font-10">E-Mail</label>
          <i class="fa fa-times invalid color-red-dark"></i>
        </div>
        <div class="clearfix"></div>
        <div class="hidden" data-id="error-container">
          <p data-id="error-text" class="pl-3 pr-3 pb-3 pt-0 error-text"></p>
        </div>
        <p style="text-align: center">
          <button data-id="btnRequestPasswordReset"
                  type="button"
                  style="margin: auto"
                  class="btn btn-l mb-3 mt-1 rounded-xs text-uppercase font-700 btn-shadow-l bg-white text-primary">Weiter</button>
        </p>
        <p class="mt-1 text-center">
          <a href="/login">Hier geht's zurück zum Login <i class="fa-solid fa-arrow-right"></i></a>
        </p>
      </form>
    </section>
    <section data-id="form-success" class="hidden">
      <h1 class="mb-4 text-white text-center">Hilfe ist unterwegs!</h1>
      <p class="mt-3 text-white font-weight-bolder text-center">
        Du erhälst in wenigen Minuten eine E-Mail mit Instruktionen, mit denen Du dir ein neues Passwort setzen kannst.
      </p>
      <p class="text-center">
        <a class="btn btn-l mt-2 rounded-xs text-uppercase font-700 btn-shadow-l bg-white text-primary" href="/login">Zurück zum Login</a>
      </p>
    </section>
  </div>
</div>
